import { Paper, Skeleton } from "@mui/material";
import React, { FC } from "react";

import { Stack } from "@components/base";

const UsersManagementSkeleton: FC = () => (
  <Paper>
    <Stack p={3}>
      <Skeleton variant="rectangular" height={50} />
    </Stack>
  </Paper>
);

export default UsersManagementSkeleton;
